import api, { ApiResponse } from './api';

interface UtilitySupportResponse {
  success: boolean;
}

// Registra pedido de "me avise quando houver suporte" a uma distribuidora
export const requestUtilitySupportService = (
  utilityName: string
): ApiResponse<UtilitySupportResponse> =>
  api({
    method: 'post',
    url: 'utility-support-requests',
    data: { utilityName },
    useToken: true,
  });
